import { cn } from '../../../lib/utils';
import { type CharlieBadgeProps, charlieBadgeVariants } from './index.js';

/**
 * CharlieBadge — React equivalent of Rocket's `RocketBadge`.
 *
 * A short label such as a status or a tag, styled like the
 * [ShadCN Badge](https://ui.shadcn.com/docs/components/badge). Every colour
 * comes from a theme token, so a themed page recolours its badges too.
 *
 * ## Variants
 *
 * Same set as RocketBadge: `default`, `secondary`, `destructive`, `outline`,
 * `success`, `warning`, `info`, `critical`, `neutral`.
 *
 * ## Usage
 *
 * ```tsx
 * import { CharlieBadge } from '@ver.id/libs.ui.charlie';
 *
 * <CharlieBadge variant="secondary">Recommended</CharlieBadge>
 * <CharlieBadge variant="neutral">Last used</CharlieBadge>
 * ```
 */
export function CharlieBadge({
  className,
  variant,
  ...props
}: CharlieBadgeProps) {
  return (
    <span
      data-slot="badge"
      className={cn(charlieBadgeVariants({ variant }), className)}
      {...props}
    />
  );
}
